import React from 'react';

// depricated, use IconCrossBu

const IconCross = props => (<svg viewBox="0 0 20 20" width="20px" height="20px" {...props}>
  <path d="M14.979 6.403l-1.381-1.382L10 8.616L6.404 5.021L5.021 6.403L8.618 10l-3.597 3.596l1.383 1.383L10 11.382l3.597 3.597 l1.381-1.383L11.383 10L14.979 6.403z" />
</svg>);

export default IconCross;
